















import Vue from 'vue';
import type { Location } from 'vue-router';
import Search from '@/components/common/Search/Search.vue';
import BravadoLogo from '@/components/global/BravadoLogo/BravadoLogo.vue';
import HeaderMenuMember from '~/components/global/HeaderMenu/HeaderMenuMember.vue';
import { WAR_ROOM_POSTS_TAB_MYFEED_PAGE } from '~/constants';

export default Vue.extend({
  name: 'HeaderMember',
  components: {
    HeaderMenuMember,
    // @ts-ignore
    Search,
    BravadoLogo,
  },
  props: {
    showOnMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    warRoomMyFeed(): Location {
      return WAR_ROOM_POSTS_TAB_MYFEED_PAGE;
    },
  },
});
